import React, { useState } from 'react';
import {
    Editor,
    EditorProvider,
    Toolbar,
    BtnBold,
    BtnItalic,
    BtnUnderline,
    BtnStrikeThrough,
    BtnBulletList,
    BtnNumberedList,
    BtnLink,
    BtnClearFormatting,
    BtnRedo,
    BtnUndo,
    BtnStyles
} from 'react-simple-wysiwyg';

export default function ContractEditor({ html, setHtml }: any) {

    return (
        <div className="w-full">
            {/* Editor */}
            <EditorProvider >
                <div>
                    <Toolbar className="flex flex-wrap sm:flex-nowrap">
                        <div className='self-center'>
                            <p className="text-[12px] font-[500] mb-2 pl-2">
                                Write Contract
                            </p>
                        </div>

                        <div className="
        ml-auto flex w-fit gap-1 rounded-full border px-3 py-2 mb-3
        overflow-x-auto sm:overflow-visible
        max-w-full
    ">
                            <BtnStyles />
                            <BtnUndo />
                            <BtnRedo />
                            <BtnBold />
                            <BtnItalic />
                            <BtnUnderline />
                            <BtnStrikeThrough />
                            <BtnBulletList />
                            <BtnNumberedList />
                            <BtnLink />
                            <BtnClearFormatting />
                        </div>
                    </Toolbar>
                    <Editor
                        autoFocus
                        containerProps={{
                            style: {
                                border: 'none',
                                minHeight: '280px',
                                maxHeight: '280px',
                                backgroundColor: '#f7f8fa',
                                borderRadius: '16px',
                                outline: 'none !important',
                                boxShadow: 'none !important',
                                padding: '8px',
                                overflowY: 'auto',
                            }
                        }}
                        value={html}
                        onChange={(e) => setHtml(e.target.value)}
                        placeholder="Start writing your contract here..."
                    />
                </div>
            </EditorProvider>
        </div>
    );
}
